import { TableContainer, Table, TableHead, TableRow, TableCell, IconButton, TableBody, Dialog, DialogTitle, DialogContent, Avatar, Tooltip } from "@material-ui/core";
import { FC, useState, useCallback } from "react";
import { FaEdit, FaExclamationCircle, FaExclamationTriangle, FaEye, FaPlus, FaRing, FaTimes, FaUserAlt } from "react-icons/fa";
import { Formater, TypeRecords, ValidateUtil } from "src/framework/commons";
import { ArrayUtil } from "src/framework/commons/ArrayUtil";
import { FullWidthButton } from "src/framework/components/buttons";
import { TabContent, TabControl } from "src/framework/components/navigations";
import { confirmationDialog, notifierStore } from "src/framework/store";
import theme from "src/theme/light";
import { DADOS_FIADORES_DEFAULT, DEFAULT_DATA_AVALISTA, ESTADO_CIVIL_CASADO_ID, FINANCEIRA_BV_ID } from "../constants";
import { FormPessoa } from "../FormPessoa";
import { IAvalistaRequestDom } from "../types";
import "./styles.scss";
import { Alert } from "@material-ui/lab";
import { Form } from "@unform/web";
import { errorsList$ } from "../../negociacao/Financiamento";

interface FormAvalistasProperties {
    avalistas: IAvalistaRequestDom[];
    errorsList?: Array<string>;
    quantidade_avalistas: number;
    readonly?: boolean;
    financeiraId?: number | null;
    onChange: (avalista: IAvalistaRequestDom[]) => void
}

interface IDadosAvalista {
    avalista: IAvalistaRequestDom | null;
    index: number;
}

const TAB_AVALISTA = "dados_avalista";
const TAB_AVALISTA_CONJUGE = "dados_avalista_conjuge";

const FormAvalistas: FC<FormAvalistasProperties> = ({
    avalistas,
    onChange,
    errorsList = [],
    quantidade_avalistas = 0,
    readonly = false,
    financeiraId,
}) => {
    const [openModalEdit, setOpenModalEdit] = useState<boolean>(false);
    const [editAvalista, setEditAvalista] = useState<IDadosAvalista>({
        avalista: null,
        index: -1
    });

    const [activeTab, setActiveTab] = useState<string>(TAB_AVALISTA)
    
    const disabled = avalistas?.length > 4 && financeiraId === FINANCEIRA_BV_ID;

    const handleChangeTabManutencao = (tab: string) => {
        setActiveTab(tab);
    }
    const validate = useCallback(() => {
        const errorMessages: string[] = []        
        const _ocupacao = editAvalista.avalista?.ocupacao;
        const _ocupacao_conjuge = editAvalista.avalista?.conjuge?.ocupacao;
        let erroProfissao = false;
        const regexBeneficio = /^(?:\d{10}|\d{3}.\d{3}.\d{3}-\d)$/m;
        
        if (_ocupacao?.categoria === "empresario"){
            const _empresa = _ocupacao.empresa;
            //validações do formulário de Avalista empresario
            if (!_ocupacao?.profissao){
                errorMessages.push('O Campo "Profissão" é obrigatório!')
            }            
            if (!_empresa?.cnpj){
                errorMessages.push('O Campo "CNPJ" é obrigatório!')
            } else if (!ValidateUtil.isValidCNPJ(String(_empresa.cnpj))) {
                errorMessages.push('O CNPJ informado é inválido!')
            }
            if (!_empresa?.nome){
                errorMessages.push('O Campo "Razão social" é obrigatório!')
            }
            if (!_empresa?.fantasia){
                errorMessages.push('O Campo "Nome fantasia" é obrigatório!')
            }
            if (!_empresa?.data_fundacao) {
                errorMessages.push('O Campo "Data de fundação" é obrigatório!')
            }
            if (!_empresa?.telefone){
                errorMessages.push('O Campo "Telefone comercial" é obrigatório!')
            }
            if (!_ocupacao?.data_inicio_ocupacao){
                errorMessages.push('O Campo "Data de início das atividades na empresa" é obrigatório!')
            }
            if (!_ocupacao?.renda_mensal){
                errorMessages.push('O Campo "Renda mensal" é obrigatório!')
            }
            if (!_empresa?.faturamento_mensal){
                errorMessages.push('O Campo "Faturamento mensal" é obrigatório!')
            }
            if (!_empresa?.capital_social){
                errorMessages.push('O Campo "Capital social" é obrigatório!')
            }
        } else if (_ocupacao?.categoria === "aposentadoOuPensionista"){
            if (!_ocupacao?.numero_beneficio){
                errorMessages.push('Na aba de dados do avalista:')
                errorMessages.push('O campo "Número do benefício" é obrigatório!')
            }else if(!regexBeneficio.test(_ocupacao?.numero_beneficio)){
                errorMessages.push('Na aba de dados do avalista:')
                errorMessages.push("O número do benefício é inválido!")
                errorsList$.next([...errorsList, `avalistas#${editAvalista.index}#numero_beneficio`])
            }else{
                errorsList$.next(errorsList.filter((error) => error !== `avalistas#${editAvalista.index}#numero_beneficio`))
            }
        }

        if(_ocupacao_conjuge?.categoria === "empresario"){
            const _empresaConjuge = _ocupacao_conjuge.empresa;

            if (!_empresaConjuge?.cnpj){
                errorMessages.push('O Campo "CNPJ" para o cônjuge é obrigatório!')
            } else if (!ValidateUtil.isValidCNPJ(String(_empresaConjuge.cnpj))) {
                errorMessages.push('O CNPJ do cônjuge informado é inválido!')
            }
        }

        erroProfissao = errorMessages?.length > 0; 
        if (editAvalista?.avalista?.telefone){
            let _phone = editAvalista?.avalista?.telefone;
            _phone = _phone?.replace(/\D/g, "");
            _phone = _phone?.replace(/^0/, "");

            if (_phone?.length !== 11){
                errorMessages.push('No campo "Telefone Celular", é obrigatório informar o DDD + 9 dígitos!')
            }
        }

        if(editAvalista?.avalista?.conjuge?.ocupacao?.categoria === "aposentadoOuPensionista"){
            const numero_beneficio_conjuge = editAvalista?.avalista?.conjuge?.ocupacao?.numero_beneficio || "";
            if(!numero_beneficio_conjuge){
                errorMessages.push('Na aba de dados do cônjuge:')
                errorMessages.push('O campo "Número do benefício" é obrigatório!')
            }
            else if(!regexBeneficio.test(numero_beneficio_conjuge)){
                errorMessages.push('Na aba de dados do cônjuge:')
                errorMessages.push("O número do benefício é inválido!")
            }
        }

        if (!editAvalista?.avalista?.nome_mae) {
            errorMessages.push('O Campo "Nome completo da mãe" é obrigatório!');
        } else {
            const value = editAvalista?.avalista?.nome_mae.trim() || "";
            const names = value?.split(" ");
            const atLeastTwoNames = names.length >= 2;
            if (!atLeastTwoNames) {
                errorMessages.push('O Campo "Nome completo da mãe" deve conter pelo menos 2 nomes!');
            }
        }

        if (editAvalista?.avalista?.estado_civil === ESTADO_CIVIL_CASADO_ID) {
            if (!editAvalista?.avalista?.conjuge?.nome_mae) {
                errorMessages.push('O Campo "Nome completo da mãe" é obrigatório!');
            } else {
                const value = editAvalista?.avalista?.conjuge?.nome_mae.trim() || "";
                const names = value?.split(" ");
                const atLeastTwoNames = names.length >= 2;
                if (!atLeastTwoNames) {
                    errorMessages.push('O Campo "Nome completo da mãe" deve conter pelo menos 2 nomes!');
                }
            }
        }

        if (errorMessages.length > 0) {
            if(erroProfissao){
                errorMessages.unshift('Em relação à seção "Dados profissionais":')
            }
            notifierStore.setNotifier({
                title: "Aviso!",
                content: errorMessages,
                timeOut: 3500,
                onClose: () => {
                    notifierStore.setOpen(false)
                }
            })
            notifierStore.setOpen(true)

            return false
        }
        return true;
    }, [editAvalista])

    return <div className="FormAvalistas">
        { quantidade_avalistas > 0 && (
            <div className="X12">
                <Alert severity="warning">
                    <p>Para esse fluxo de financiamento só serão aceitos <strong>Sócios e/ou Proprietários</strong> como avalistas.</p>
                </Alert>
            </div>
        )}
        <TableContainer>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell align="right"></TableCell>
                        <TableCell align="left">Nome completo</TableCell>
                        <TableCell align="left">Documento</TableCell>
                        <TableCell align="left">Data de nascimento</TableCell>
                        <TableCell align="right">
                            <div className="content">
                                <Tooltip title={disabled ? "Você cadastrou a quantidade máxima de avalistas." : "Adicionar avalista"} placement="bottom">
                                    <span>
                                        <IconButton
                                            size="small"
                                            disabled={disabled}
                                            onClick={() => {
                                                if (disabled) return;
                                                const newAvalista = { ...DEFAULT_DATA_AVALISTA }
                                                setEditAvalista({ avalista: newAvalista, index: -1 })
                                                setOpenModalEdit(true)
                                            }}
                                        >
                                            <FaPlus />
                                        </IconButton>
                                    </span>
                                </Tooltip>
                            </div>
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {avalistas?.map((_avalista, index) => {
                        return <TableRow key={`fiador-row-${index}`}>
                            <TableCell align="right">{`#${index + 1}`}</TableCell>
                            <TableCell>{_avalista?.nome}<sup>{ArrayUtil.contains(errorsList, `avalistas#${index}#`) && <FaExclamationCircle color={theme.palette.error.main} />}</sup></TableCell>
                            <TableCell>{_avalista?.documento ? Formater.toString(_avalista?.documento?.replace(/\D/g, ""), TypeRecords.CPF_CNPJ) : ""}</TableCell>
                            <TableCell>{Formater.toString(_avalista?.data_nascimento, TypeRecords.DATE)}</TableCell>
                            <TableCell align="right">
                                <IconButton
                                    size="small"
                                    onClick={() => {
                                        const __avalista = { ...DEFAULT_DATA_AVALISTA, ...avalistas[index] };
                                        if (!__avalista?.endereco) {
                                            __avalista.endereco = DADOS_FIADORES_DEFAULT.endereco
                                        }
                                        if (!__avalista?.conjuge) {
                                            __avalista.conjuge = DADOS_FIADORES_DEFAULT.conjuge

                                        }

                                        setEditAvalista({
                                            avalista: __avalista,
                                            index: index
                                        })
                                        // handleValidChange();
                                    }}
                                >
                                    {readonly ? <FaEye /> : <FaEdit />}
                                </IconButton>
                                {readonly ? "" : <IconButton
                                    disabled={readonly}
                                    size="small"
                                    onClick={() => {
                                        confirmationDialog.setup({
                                            title: "Aviso!!!",
                                            content: "Remover avalista?",
                                            onClose: () => {
                                                confirmationDialog.close()
                                            },
                                            onConfirmation: () => {
                                                avalistas.splice(index, 1);
                                                onChange([...avalistas])
                                                confirmationDialog.close()
                                            },

                                        })
                                        confirmationDialog.open()
                                    }}
                                >
                                    <FaTimes color={theme.palette.error.main} />
                                </IconButton>}
                            </TableCell>
                        </TableRow>
                    })}
                    {!avalistas?.length && <>
                        <TableRow>
                            <TableCell colSpan={5} align="center" >
                                <FaExclamationTriangle color={theme.palette.warning.main} style={{ fontSize: "29px" }} />
                                <div>Nenhum avalista cadastrado</div>
                            </TableCell>
                        </TableRow>
                    </>}
                </TableBody>
            </Table>
        </TableContainer>

        <Dialog className="FinanciamentoFormAvalista" open={editAvalista.avalista !== null} maxWidth="md">
            <DialogTitle>Formulário Avalista</DialogTitle>
            <DialogContent>
                <TabControl
                    currentTabName={activeTab}
                    onChangeTab={handleChangeTabManutencao}
                    indicatorColor="primary"
                    textColor="primary"
                >
                    <TabContent 
                        name={TAB_AVALISTA} 
                        visible={true}
                        label={<>
                        <Avatar variant="rounded" color={theme.palette.primary.main}>
                            <FaUserAlt />
                        </Avatar> Dados Pessoais</>} 
                    >

                        <FormPessoa
                            key={`form-pessoa-avalista`}
                            dados={editAvalista.avalista}
                            isAvalista
                            isPessoaFisica
                            isConjuge={false}
                            indexAvalista={editAvalista?.index}
                            financeira_id={financeiraId || 0}
                            onChange={(_avalista, _tipoPessoa) => {
                                const _state = { ...editAvalista }
                                if (_state?.avalista) {
                                    _state.avalista = _avalista
                                    setEditAvalista(_state)
                                }
                            }}
                        />
                    </TabContent>
                    <TabContent name={TAB_AVALISTA_CONJUGE} label={<>
                        <Avatar variant="rounded" color={theme.palette.primary.main}>
                            <FaRing />
                        </Avatar> Dados Cônjuge</>} visible={editAvalista?.avalista?.estado_civil === ESTADO_CIVIL_CASADO_ID}>
                        {editAvalista?.avalista?.estado_civil === ESTADO_CIVIL_CASADO_ID && <div className="row">
                            <div className="X12">
                                <FormPessoa
                                    key={`form-pessoa-avalista-conjuge`}
                                    readonly={readonly}
                                    indexAvalista={editAvalista?.index}
                                    dados={editAvalista?.avalista?.conjuge as any}
                                    isConjuge
                                    isAvalista
                                    isPessoaFisica
                                    financeira_id={financeiraId || 0}
                                    onChange={(_dados, _tipoPessoa) => {
                                        const _state = { ...editAvalista }
                                        if (_state?.avalista) {
                                            _state.avalista.conjuge = _dados
                                            setEditAvalista(_state)
                                        }
                                    }}
                                // dadosCliente={dadosCliente}
                                // isValid={(_valid) => {
                                //     if (isValid) {
                                //         isValid(_valid)
                                //     }
                                // }}
                                />
                            </div>
                        </div>}
                    </TabContent>
                </TabControl>
            </DialogContent>

            <div className="row actions">
                <div className="X12 M6 X--order2 M--order1">
                    <FullWidthButton
                        onClick={() => {
                            setOpenModalEdit(false);
                            setEditAvalista({
                                avalista: null,
                                index: -1
                            });
                        }}
                        text="Fechar"
                    />
                </div>
                <div className="X12 M6 X--order1 M--order2">
                    <FullWidthButton
                        // disabled={readonly || disabledEnviar || errorList.length > 0}
                        color="primary"
                        variant="contained"
                        disableElevation
                        onClick={() => {
                            if (!validate()) {
                                return;
                            }
                            confirmationDialog.setup({
                                title: "Aviso!!!",
                                content: "Salvar este avalista?",
                                onClose: () => {
                                    confirmationDialog.close()
                                },
                                onConfirmation: () => {
                                    const avalistasState = [...avalistas]
                                    if (editAvalista?.avalista) {
                                        if (editAvalista.avalista && editAvalista.index > -1) {
                                            avalistasState[editAvalista.index] = editAvalista.avalista
                                        } else {
                                            avalistasState.push(editAvalista.avalista)
                                        }
                                    }
                                    onChange(avalistasState)
                                    editAvalista.avalista = null;
                                    editAvalista.index = -1;
                                    setEditAvalista({ ...editAvalista });
                                    confirmationDialog.close();
                                    setOpenModalEdit(false)
                                },

                            })

                            confirmationDialog.open()
                        }}
                        text="Salvar avalista"
                    />
                </div>
            </div>
        </Dialog>
    </div>
}

export { FormAvalistas }